import {useCallback} from 'react';
import axiosInstance from "../axiosInstance";

const useGetProductStatus = () => {
  return useCallback(({productId}) => {
    const baseUrl = window.localStorage.getItem("BaseURL")
    const endpoint = `/services/projectmanagement/api/products/${productId}/status`
    const fullUrl = baseUrl + endpoint;

    return new Promise((resolve, reject) => {
      axiosInstance.get(fullUrl)
        .then((res) => resolve(res.data))
        .catch(reject)
    })
  }, [])
};

export default useGetProductStatus;
